/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import React, { createContext, useContext, useState } from "react";
import { Message } from "../constants/message";

export const MessageContext: React.Context<any> = createContext(null);
export const MessageProvider = ({ children }: any) => {
  const [message, setMessage] = useState<Message | null>(null);

  return (
    <MessageContext.Provider value={{ message, setMessage }}>
      {children}
    </MessageContext.Provider>
  );
};

export const useMessageValue = () => useContext(MessageContext);
